import React from 'react';
import { HeroV2 } from '../components/HeroV2';
import { PartnerLogos } from '../components/PartnerLogos';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { SystemsWeInstall } from '../components/SystemsWeInstall';
import { Advantages } from '../components/Advantages';
import { Testimonial } from '../components/Testimonial';
import { News } from '../components/News';
import { QuoteForm } from '../components/QuoteForm';
export function HomeV2() {
  return <main id="main-content" data-id="element-1075">
      <HeroV2 data-id="element-1076" />
      <PartnerLogos data-id="element-1077" />
      <Stats data-id="element-1078" />
      <Services data-id="element-1079" />
      <SystemsWeInstall data-id="element-1080" />
      <Advantages data-id="element-1081" />
      <Testimonial data-id="element-1082" />
      <News data-id="element-1083" />
      <QuoteForm data-id="element-1084" />
    </main>;
}